export const shortcutColors = [
  {
    rgbTop: "rgb(252, 17, 57)",
    rgbBottom: "rgb(182, 0, 23)",
    workflowColor: "4282601983"
  },
  {
    rgbTop: "rgb(239, 95, 62)",
    rgbBottom: "rgb(206, 23, 0)",
    workflowColor: "4251333119"
  },
  {
    rgbTop: "rgb(255, 127, 35)",
    rgbBottom: "rgb(214, 68, 0)",
    workflowColor: "4271458815"
  },
  {
    rgbTop: "rgb(236, 181, 0)",
    rgbBottom: "rgb(221, 112, 0)",
    workflowColor: "4274264319"
  },
  {
    rgbTop: "rgb(90, 206, 58)",
    rgbBottom: "rgb(46, 140, 14)",
    workflowColor: "4292093695"
  },
  {
    rgbTop: "rgb(75, 209, 169)",
    rgbBottom: "rgb(0, 149, 125)",
    workflowColor: "431817727"
  },
  {
    rgbTop: "rgb(69, 209, 206)",
    rgbBottom: "rgb(0, 134, 181)",
    workflowColor: "1440408063"
  },
  {
    rgbTop: "rgb(79, 162, 240)",
    rgbBottom: "rgb(1, 97, 216)",
    workflowColor: "463140863"
  },
  {
    rgbTop: "rgb(46, 101, 220)",
    rgbBottom: "rgb(0, 48, 172)",
    workflowColor: "946986751"
  },
  {
    rgbTop: "rgb(108, 62, 231)",
    rgbBottom: "rgb(58, 0, 168)",
    workflowColor: "2071128575"
  },
  {
    rgbTop: "rgb(174, 56, 219)",
    rgbBottom: "rgb(109, 0, 155)",
    workflowColor: "3679049983"
  },
  {
    rgbTop: "rgb(243, 89, 165)",
    rgbBottom: "rgb(193, 10, 107)",
    workflowColor: "3980825855"
  },
  {
    rgbTop: "rgb(109, 110, 115)",
    rgbBottom: "rgb(64, 66, 69)",
    workflowColor: "255"
  },
  {
    rgbTop: "rgb(146, 145, 136)",
    rgbBottom: "rgb(105, 103, 87)",
    workflowColor: "3031607807"
  },
  {
    rgbTop: "rgb(134, 143, 169)",
    rgbBottom: "rgb(87, 97, 120)",
    workflowColor: "2846468607"
  }
];



// WEBPACK FOOTER //
// ./src/assets/shortcutColors.js